import { List, Stack, StackProps } from "@mui/material";
import { DrawerNavMenuItem } from "./DrawerNavMenuItem";
import type { NavItem, NavItems } from "./navItems";

interface DrawerNavMenuProps extends Omit<StackProps, "children"> {
  items: NavItems;
}

function renderItems(items: NavItem[]) {
  return items.map((item) => (
    <DrawerNavMenuItem
      key={item.id}
      icon={item.icon}
      label={item.label}
      tooltip={item.label}
      path={item.path}
    />
  ));
}

/**
 * Navigation menu. The shell builds `items` from the module registry
 * (src/app/modules.tsx) and leaves out what the user can't open; add a page
 * there, not here, so routing and nav can't drift apart.
 */
export function DrawerNavMenu({ items, ...props }: DrawerNavMenuProps) {
  return (
    <Stack justifyContent="space-between" flexGrow={1} width="100%" {...props}>
      {/* Primary Navigation */}
      <List disablePadding>{renderItems(items.primary)}</List>

      {/* Secondary Navigation */}
      <List disablePadding>{renderItems(items.secondary)}</List>
    </Stack>
  );
}
